import activity from './activity.nl.json';
import assets from './assets.nl.json';
import auth from './auth.nl.json';
import commissions from './commissions.nl.json';
import common from './common.nl.json';
import dashboard from './dashboard.nl.json';
import payouts from './payouts.nl.json';
import profile from './profile.nl.json';
import rewards from './rewards.nl.json';
import rewardsV3 from './rewardsV3.nl.json';
import shareLink from './shareLink.nl.json';
import stats from './stats.nl.json';
import transactions from './transactions.nl.json';

const nl = {
  activity,
  assets,
  auth,
  commissions,
  common,
  dashboard,
  payouts,
  profile,
  rewards,
  rewardsV3,
  shareLink,
  stats,
  transactions,
};

export default nl;
